import { SnackbarCloseReason } from '@mui/base';
import React, {
  PropsWithChildren,
  ReactElement,
  useCallback,
  useEffect,
  useState
} from 'react';

import { ErrorSnackbar } from '../components/ErrorSnackbar';

export type ErrorDisplayContextValue = {
  displayError: (error: unknown) => void;
};

export const ErrorDisplayContext =
  React.createContext<ErrorDisplayContextValue>(undefined!);

type ErrorDisplayProviderProps = PropsWithChildren;

export const ErrorDisplayProvider = ({
  children
}: ErrorDisplayProviderProps): ReactElement => {
  const [errorQueue, setErrorQueue] = useState<unknown[]>([]);
  const displayError = useCallback((error: unknown) => {
    if (!error) {
      return;
    }
    setErrorQueue(prev => [...prev, error]);
  }, []);

  const [open, setOpen] = useState(false);

  const handleClose = useCallback(
    (_: unknown, reason?: SnackbarCloseReason) => {
      if (reason === 'clickaway') {
        return;
      }

      setOpen(false);
      if (errorQueue.length > 0) {
        setErrorQueue(prev => prev.slice(1));
      }
    },
    [errorQueue.length]
  );

  useEffect(() => {
    if (errorQueue.length > 0) {
      setOpen(true);
    }
  }, [errorQueue.length]);

  const value = {
    displayError
  };
  return (
    <ErrorDisplayContext.Provider value={value}>
      {children}
      {errorQueue.length > 0 ? (
        <ErrorSnackbar
          open={open}
          onClose={handleClose}
          error={errorQueue[0]}
        />
      ) : null}
    </ErrorDisplayContext.Provider>
  );
};
